import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { MidwayAuthProvider } from './auth/MidwayAuthContext';
import './styles/global.css';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <MidwayAuthProvider>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </MidwayAuthProvider>
  </React.StrictMode>
);
